import gsap from 'gsap';
import { TextPlugin } from 'gsap/TextPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(TextPlugin);

export const initWelcomeLoader = (userName, startSiteCallback) => {
    return new Promise((resolve) => {
        const overlay  = document.getElementById('loader-welcome');
        const bonjour  = document.getElementById('welcome-bonjour');
        const nameEl   = document.getElementById('welcome-name');

        if (!overlay || !nameEl) {
            if (startSiteCallback) startSiteCallback();
            resolve();
            return;
        }

        gsap.set(overlay, { display: 'flex' });

        const splitToSpans = (el, text) => {
            el.innerHTML = '';
            return text.split('').map(char => {
                const span = document.createElement('span');
                span.textContent = char === ' ' ? '\u00A0' : char;
                span.style.display = 'inline-block';
                el.appendChild(span);
                return span;
            });
        };

        const bonjourChars = splitToSpans(bonjour, 'Bonjour');
        const nameChars    = splitToSpans(nameEl, userName);
        const allChars     = [...bonjourChars, ...nameChars];

        const tl = gsap.timeline({
            onComplete: () => {
                gsap.to(overlay, {
                    opacity: 0,
                    duration: 0.6,
                    ease: 'power2.inOut',
                    delay: 0.4,
                    // FIX : startSiteCallback pendant le fade-out pour que le site
                    // soit initialisé avant que l'overlay disparaisse complètement
                    onStart: () => { if (startSiteCallback) startSiteCallback(); },
                    onComplete: () => {
                        overlay.remove();
                        // FIX : refresh APRÈS que l'overlay soit sorti du DOM
                        ScrollTrigger.refresh(true);
                        resolve();
                    }
                });
            }
        });

        tl.from(allChars, {
            opacity: 0,
            y: 20,
            duration: 0.4,
            ease: 'power3.out',
            stagger: 0.05,
        });
    });
};